module.exports = __webpack_public_path__ + "img/cub2-6_100.prt.b4d8b225.jpg";